export default {
  id: 39,
  title: 'Target #39 - Sunset',
  url: 'https://cssbattle.dev/play/39',
  colors: ['#1A4341', '#F3AC3C', '#998235'],
  solution:
    '<a a><a b><a c><style>body{background:#1A4341}a{position:fixed}a[a],a[b]{border-radius:50%}a[a]{background:#998235;width:200;height:200;top:50;left:100}a[b]{background:#F3AC3C;width:250;height:250;top:25;left:75;clip:rect(75,250,175,0)}a[c]{background:#1A4341;width:385;height:20;top:80;box-shadow:0 40px #1A4341,0 80px #1A4341,0 120px #1A4341}</style>',
}
